import Cookies from 'js-cookie';
import languages from '../../languages/language.setting';

const ACTIVE_LANGUAGES = ['eng', 'esp'];
const DEFAULT_LANGUAGE = 'eng';

export function getCurrentLanguageKey() {
  const cookieLanguage = Cookies.get('language');

  if (ACTIVE_LANGUAGES.indexOf(cookieLanguage) !== -1) {
    return cookieLanguage;
  }

  Cookies.set('language', DEFAULT_LANGUAGE);
  return DEFAULT_LANGUAGE;
}

export function getLanguageSection(sectionName) {
  const languageKey = getCurrentLanguageKey();
  return languages[languageKey][sectionName];
}

export function toggleSiteLanguage() {
  const currentLanguage = Cookies.get('language');
  Cookies.set('language', currentLanguage === 'eng' ? 'esp' : 'eng');

  const location = window.location;
  const url = new URL(location);
  const lang = url.searchParams.get('lang');

  if (lang) {
    const langPosition = location.href.indexOf('lang');
    const urlWithoutLang = location.href.substring(0, langPosition - 1);
    const canadaPosition = location.href.indexOf('iscanada');

    window.location.href = canadaPosition === -1
      ? urlWithoutLang
      : `${urlWithoutLang}?iscanada=${Cookies.get('iscanada')}`;
  } else {
    window.location.href = location.href;
  }
}
